var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-divider'),_c('MantenedorGrid',_vm._b({attrs:{"grid-options":_vm.enrichedGridOptions}},'MantenedorGrid',Object.assign({}, _vm.$props, _vm.$attrs),false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }